import Funcionario from "./Funcionario";

const Operador = {
    ...Funcionario
}

export default Operador;